import { Model } from "./Model";

export interface LiveScore extends Model {
	awayLogo:string;
	awayName: string;
	awayScore:number;
	homeLogo:string;
	homeName: string;
	homeScore:number;
	leagueId: number;
	leagueName: string;
	status: string;
}

export class LiveScore implements LiveScore {

	constructor(data?: Partial<LiveScore>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}